module.exports = __webpack_public_path__ + "img/hotels-1.9029ef16.png";